import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '50px', textAlign: 'center', color: 'white' }}>
          <h1>Something went wrong.</h1>
          <p>Please try refreshing the page.</p>
          <a href="/" style={{ color: '#4da6ff' }}>Go back to Home</a>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
